import React from 'react';

import { useSlidingCards } from '../hooks/useSlidingCards';
import { useScrollToSelectedElement } from '../hooks/useScrollToSelectedElement';

import SlidingCard from './SlidingCard';
import Filters from './Filters';
import BlockContent from './BlockContent';
import Testimonial from './Testimonial';

export default function SlidingCards({
  section,
  isTestimonials,
  isFilterBar = true
}) {
  const { references, blockContent } = section || {};
  const {
    scrollingContainer,
    isCardTransparent,
    handleClick,
    selectedElement
  } = useSlidingCards(references);

  {
    isFilterBar && useScrollToSelectedElement(selectedElement);
  }

  return (
    <>
      <div className="sliding-cards">
        <BlockContent content={blockContent} />
        {references && (
          <>
            {isFilterBar && (
              <Filters
                filters={references}
                handleClick={handleClick}
                selectedElement={selectedElement}
                isSliding
              />
            )}

            <div ref={scrollingContainer} className="sliding-cards__container">
              {references.map((card, i) => (
                <div
                  key={card.id}
                  className={`${isCardTransparent(i) ? '--transparent' : ''}`}
                >
                  {isTestimonials ? (
                    <Testimonial testimonial={card} />
                  ) : (
                    <SlidingCard card={card} />
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
}
